import { FC } from 'react';
import { PaginationItem, Stack } from '@mui/material';
import {
  gridPageSizeSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import Button from '@/components/button';
import { PaginationProps } from '../helpers';

const PaginationAction: FC<PaginationProps> = ({
  page,
  onPageChange,
  className = '',
  isCursorMode,
  enablePolling,
  onPollingChange,
}) => {
  const apiRef = useGridApiContext();
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

  return (
    <Stack direction="row" alignItems="center" className={className}>
      {isCursorMode && (
        <Button
          onClick={onPollingChange}
          icon={enablePolling ? 'live' : 'first-page'}
          label="Live"
          type={enablePolling ? 'submit' : 'option'}
          size="small"
        />
      )}
      <MuiPagination
        color="standard"
        className={className}
        count={Math.ceil(rowCount / pageSize)}
        page={page + 1}
        onChange={(_event, newPage) => {
          onPageChange(null, newPage - 1);
        }}
        renderItem={(item) => {
          const { type, selected } = item;
          if (
            !isCursorMode ||
            ['next', 'previous'].includes(type) ||
            (type === 'page' && selected)
          ) {
            return <PaginationItem {...item} />;
          }

          return null;
        }}
      />
    </Stack>
  );
};

export default PaginationAction;
